<template>
  <span>
    <div class="col-md-12">
      <div class="table-responsive">
        <table id="dataTableExample" class="table table-hover">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Supplier</th>
              <th>Is Email Triggered</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <loading-table :isLoading="isLoading" cols="14"></loading-table>
            <tr v-if="form.rfq_suppliers.length == 0">
              <td colspan="14" class="text-center">No data Found</td>
            </tr>
            <tr
              v-for="(rfq_supplier, sr) in form.rfq_suppliers"
              :key="`rfq_supplier${sr}`"
            >
              <td>{{ sr + 1 }}.</td>
              <td>
                <my-select
                  disableFormControl="true"
                  :selection.sync="rfq_supplier.supplier_id"
                  :suggestions="suppliers"
                  placeholder="Select Ssupplier"
                ></my-select>
              </td>
              <td>
                <div class="form-check form-switch mb-2">
                  <input
                    type="checkbox"
                    v-model="rfq_supplier.is_email_triggered"
                    class="form-check-input"
                    :id="`is_email_triggered${sr}`"
                  />
                </div>
              </td>

              <td>
                <div class="text-center">
                  <button
                    class="btn btn-danger btn-sm"
                    @click="deleteRfqSupplier(rfq_supplier)"
                    v-if="!rfq_supplier.id"
                  >
                    Delete
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="delete_rfq_supplier_data(rfq_supplier.id)"
                    v-else
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="form.rfq_suppliers">
              <td
                colspan="14"
                align="center"
                @click="addEmptyRfqSuppliers()"
                style="
                  background-color: #6571ff;
                  color: white;
                  border-radius: 10px;
                  box-shadow: none;
                "
              >
                Add New Row
              </td>
            </tr>
          </tbody>
        </table>
        <!-- /Table -->
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "RfqSupplierFormWidget",
  props: ["form"],
  data() {
    return {
      suppliers: [
        { id: 1, name: "Supplier 1" },
        { id: 2, name: "Supplier 2" },
      ],
      isLoading: false,
    };
  },

  methods: {
    deleteRfqSupplier(speed) {
      this.form.rfq_suppliers = this.form.rfq_suppliers.filter(
        (ar) => ar != speed
      );
    },
    addEmptyRfqSuppliers() {
      this.form.rfq_suppliers.push({
        company_id: this.company.id,
        supplier_id: "",
        is_email_triggered: "",
      });
    },
    async delete_rfq_supplier_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=rfq_suppliers`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
